import {Nut_Settings_User} from 'nutshell-core/settings-constants';

import type {GetSessionUser_loggedInUser as User} from 'nutshell-graphql-types';

import {bindKeyboardShortcuts, unbindKeyboardShortcuts} from '../../../keyboard-shortcuts';
// @ts-expect-error
import {refreshUser} from '../../../user';

import {useUpdateUserSetting} from '../../core/use-update-user-setting';

export function useToggleShortcuts() {
    const updateSetting = useUpdateUserSetting();

    const toggleShortcuts = (user: User) => {
        const value = user.hasDisabledShortcuts ? '0' : '1';

        updateSetting({
            userId: user.id,
            settingName: Nut_Settings_User.SETTING_SHORTCUTS_DISABLED,
            value,
            propertyOnUser: 'hasDisabledShortcuts',
        }).then(() => {
            if (user.hasDisabledShortcuts) {
                bindKeyboardShortcuts(user.permissions.canAccessSetup);
            } else {
                unbindKeyboardShortcuts();
            }

            refreshUser(user.id);
        });
    };

    return toggleShortcuts;
}
